import api from './api';

const getMode = () => localStorage.getItem('duckpilot_mode') || 'auth';

const ensureAuth = () => {
  const token = localStorage.getItem('access_token');
  if (!token) {
    const error = new Error('auth_required');
    error.code = 'auth_required';
    throw error;
  }
};

const recordUpload = async () => {
  const mode = getMode();
  if (mode === 'demo') {
    return null;
  }
  ensureAuth();
  const response = await api.post('/api/usage/record-upload');
  return response.data;
};

const recordQuery = async () => {
  const mode = getMode();
  if (mode === 'demo') {
    return null;
  }
  ensureAuth();
  const response = await api.post('/api/usage/record-query');
  return response.data;
};

const usageService = {
  recordUpload,
  recordQuery,
};

export default usageService;
